<template>
    <div class="container">
        <menus></menus>
        <div class="main">
            <!-- 内容 -->
            <div class="user">
                <span>{{ $t('welcome.welcome') }}</span><span>{{ phone }}</span><span @click="signOut" style="color:#fff">{{
                    $t('welcome.signOut') }}</span>
            </div>
            <div>
                <div class="mainTitle">{{ $t('agenda.title') }}</div>
                <div class="mainBody" style="padding: .3 rem;">
                    <img class='preview-img' width='100%' widths="1500" heights="2480"
                        @click="bigImg"
                         links="https://oss.eventnet.cn/H5/Nissan_meeting/2024/agenda.jpg?v=12231630"
                        :src="$i18n.locale == 'jp' ? 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/agenda.png?v=12231630' : 'https://oss.eventnet.cn/H5/Nissan_meeting/2024/agenda.png?v=12231630'">
                    <div v-if="agenda">
                        <p class="agendaTitle"><span>{{ $t('agenda.day22') }}</span></p>
                        <table width="100%" border="0" cellspacing="0" cellpadding="0"
                            style="border-collapse: collapse;" class="agendaTable">
                            <tbody>
                                <tr>
                                    <td valign="top">{{ $t('agenda.day22_text.text1') }}<span class="dian"></span></td>
                                    <td valign="top">{{ $t('agenda.day22_text.text2') }}</td>
                                    <td valign="top">{{ $t('agenda.day22_text.text3') }}</td>
                                </tr>
                                <tr>
                                    <td valign="top">{{ $t('agenda.day22_text.text4') }}<span class="dian"></span></td>
                                    <td valign="top">{{ $t('agenda.day22_text.text5') }}</td>
                                    <td valign="top">{{ $t('agenda.day22_text.text6') }}</td>
                                </tr>
                                <tr>
                                    <th colspan="3"></th>
                                </tr>
                            </tbody>
                        </table>
                        <p class="agendaTitle"><span>{{ $t('agenda.day23') }}</span></p>
                        <table width="100%" border="0" cellspacing="0" cellpadding="0"
                            style="border-collapse: collapse;" class="agendaTable">
                            <tbody>
                                <tr>
                                    <td valign="top">{{ $t('agenda.day23_text.text1') }}<span class="dian"></span></td>
                                    <td valign="top">{{ $t('agenda.day23_text.text2') }}</td>
                                    <td valign="top">{{ $t('agenda.day23_text.text3') }}</td>
                                </tr>
                                <tr>
                                    <td valign="top">{{ $t('agenda.day23_text.text4') }}<span class="dian"></span></td>
                                    <td valign="top">{{ $t('agenda.day23_text.text5') }}</td>
                                    <td valign="top">{{ $t('agenda.day23_text.text6') }}</td>
                                </tr>
                                <tr>
                                    <td valign="top">{{ $t('agenda.day23_text.text7') }}<span class="dian"></span></td>
                                    <td valign="top">{{ $t('agenda.day23_text.text8') }}</td>
                                    <td valign="top">{{ $t('agenda.day23_text.text9') }}<br><span
                                            v-if="$i18n.locale == 'zh'">{{ $t('agenda.day23_text.text999')
                                            }}<br></span><small>（{{ $t('agenda.day23_text.text99') }}）</small>
                                    </td>
                                </tr>
                                <tr>
                                    <td valign="top">
                                        {{ $t('agenda.day23_text.text10')
                                        }}<br>{{ $t('agenda.day23_text.text100') }}<span
                                            class="dian"></span></td>
                                    <td valign="top">{{ $t('agenda.day23_text.text11') }}</td>
                                    <td valign="top">{{ $t('agenda.day23_text.text12') }}</td>
                                </tr>
                                <tr>
                                    <td valign="top">{{ $t('agenda.day23_text.text13') }}<span class="dian"></span></td>
                                    <td valign="top">{{ $t('agenda.day23_text.text14') }}</td>
                                    <td valign="top">{{ $t('agenda.day23_text.text15') }}</td>
                                </tr>
                                <tr>
                                    <td valign="top">{{ $t('agenda.day23_text.text16') }}<span class="dian"></span></td>
                                    <td valign="top">{{ $t('agenda.day23_text.text17') }}</td>
                                    <td valign="top">{{ $t('agenda.day23_text.text18') }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="agendaTitle"><span>{{ $t('agenda.day24') }}</span></p>
                        <table width="100%" border="0" cellspacing="0" cellpadding="0"
                            style="border-collapse: collapse;" class="agendaTable">
                            <tbody>
                                <tr>
                                    <td valign="top">{{ $t('agenda.day24_text.text1') }}<span class="dian"></span></td>
                                    <td valign="top">{{ $t('agenda.day24_text.text2') }}</td>
                                    <td valign="top">{{ $t('agenda.day24_text.text3') }}</td>
                                </tr>
                                <tr>
                                    <td valign="top">{{ $t('agenda.day24_text.text4') }}<span class="dian"></span></td>
                                    <td valign="top">{{ $t('agenda.day24_text.text5') }}</td>
                                    <td valign="top">{{ $t('agenda.day24_text.text6') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="back" @click="path('menu')" :style="{ 'font-size': $i18n.locale == 'jp' ? '.2rem' : '.28rem' }">
            <!-- {{$t('back.back')}} -->
            <img width="100%" src="https://oss.eventnet.cn/H5/Nissan_meeting/2024/back.png" alt="">
        </div>
        <Photo class="img_big" :items="items" v-if="bigImg_show" @show="close" />
    </div>
</template>
<script>
import menus from "../components/menu.vue"
import Photo from "../components/PhotoSwipe.vue"
export default {
    components: {
        menus,
        Photo
    },
    name: "menuView",
    data() {
        return {
            phone: localStorage.getItem("nissan2023_meeting_mobile"),
            agenda: false,
            items: [{
                src: '',
                w: 0,
                h: 0,
            },],
            bigImg_show: false,
        }
    },

    created() {

        //_hmt.push(['_trackPageview', '/agenda']);
    },
    mounted() {
        // this.alerts3("<p style='text-align:left;'>" + this.$t('tips.tips3') + "</p>");
    },
    methods: {
        alerts3(content) {
            layer.open({
                title: [
                    this.$t('tips.tips1'),
                    'background-color: #c61533; color:#fff;'
                ],
                content: content,
                btn: this.$t('tips.tips2'),
                yes: function (index) {
                    layer.closeAll();
                }
            });
        },
        signOut() {
            localStorage.removeItem("nissan2023_meeting_uuid")
            this.$router.replace('/login');
        },
        path(path) {
            this.$router.replace('/' + path)
        },
        bigImg(el) {
            this.items[0].w = el.target.getAttribute('widths');
            this.items[0].h = el.target.getAttribute('heights');
            this.items[0].src = el.target.getAttribute('links');
            this.bigImg_show = true;
        },
        close(e) {
            this.bigImg_show = e;
        },
    }
}
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/agenda.vue